import { render } from "./BatteryBooster.vue?vue&type=template&id=3f9a7d66"
import script from "./BatteryBooster.vue?vue&type=script&lang=js"
export * from "./BatteryBooster.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__